export const teethConfig = {
    topRight: {
        maxX: 590,
        maxY: 80,
        minX: 50,
        minY: 20,
        values: [
            {
                value: 0,
                positionX: 90,
                positionY: 50,
                boundX: 130,
            },
            {
                value: 1,
                positionX: 170,
                positionY: 50,
                boundX: 210,
            },
            {
                value: 2,
                positionX: 255,
                positionY: 50,
                boundX: 300,
            },
            {
                value: 3,
                positionX: 330,
                positionY: 50,
                boundX: 365,
            },
            {
                value: 4,
                positionX: 400,
                positionY: 50,
                boundX: 430,
            },
            {
                value: 5,
                positionX: 460,
                positionY: 50,
                boundX: 482,
            },
            {
                value: 6,
                positionX: 510,
                positionY: 50,
                boundX: 540,
            },
            {
                value: 7,
                positionX: 565,
                positionY: 50,
                boundX: 590,
            },
        ],
    },
    topLeft: {
        maxX: 1130,
        maxY: 80,
        minX: 590,
        minY: 20,
        values: [
            {
                value: 8,
                positionX: 620,
                positionY: 50,
                boundX: 650,
            },
            {
                value: 9,
                positionX: 670,
                positionY: 50,
                boundX: 700,
            },
            {
                value: 10,
                positionX: 725,
                positionY: 50,
                boundX: 750,
            },
            {
                value: 11,
                positionX: 780,
                positionY: 50,
                boundX: 820,
            },
            {
                value: 12,
                positionX: 850,
                positionY: 50,
                boundX: 885,
            },
            {
                value: 13,
                positionX: 928,
                positionY: 50,
                boundX: 970,
            },
            {
                value: 14,
                positionX: 1010,
                positionY: 50,
                boundX: 1050,
            },
            {
                value: 15,
                positionX: 1092,
                positionY: 50,
                boundX: 1130,
            },
        ],
    },
    bottomRight: {
        maxX: 590,
        maxY: 250,
        minX: 50,
        minY: 180,
        values: [
            {
                value: 16,
                positionX: 90,
                positionY: 220,
                boundX: 130,
            },
            {
                value: 17,
                positionX: 170,
                positionY: 220,
                boundX: 210,
            },
            {
                value: 18,
                positionX: 255,
                positionY: 220,
                boundX: 300,
            },
            {
                value: 19,
                positionX: 330,
                positionY: 220,
                boundX: 365,
            },
            {
                value: 20,
                positionX: 400,
                positionY: 220,
                boundX: 430,
            },
            {
                value: 21,
                positionX: 460,
                positionY: 220,
                boundX: 482,
            },
            {
                value: 22,
                positionX: 510,
                positionY: 220,
                boundX: 540,
            },
            {
                value: 23,
                positionX: 565,
                positionY: 220,
                boundX: 590,
            },
        ],
    },
    bottomLeft: {
        maxX: 1130,
        maxY: 250,
        minX: 590,
        minY: 180,
        values: [
            {
                value: 24,
                positionX: 620,
                positionY: 220,
                boundX: 650,
            },
            {
                value: 25,
                positionX: 670,
                positionY: 220,
                boundX: 700,
            },
            {
                value: 26,
                positionX: 725,
                positionY: 220,
                boundX: 750,
            },
            {
                value: 27,
                positionX: 780,
                positionY: 220,
                boundX: 820,
            },
            {
                value: 28,
                positionX: 850,
                positionY: 220,
                boundX: 885,
            },
            {
                value: 29,
                positionX: 928,
                positionY: 220,
                boundX: 970,
            },
            {
                value: 30,
                positionX: 1010,
                positionY: 220,
                boundX: 1050,
            },
            {
                value: 31,
                positionX: 1092,
                positionY: 220,
                boundX: 1130,
            },
        ],
    },
};
